import React from "react";
import {useForm} from "react-hook-form";
import {View, Text, StyleSheet} from "react-native";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import {Button} from '../../../components/core/Button';
import {
  globalConfigurableData,
  globalConst,
} from "../../../utils/globalConstant";
import {cancel_black, cancel_no, cancel_yes} from "../../../utils/images";
import {Network} from "../../../utils/network";
import {
  defaultRange,
  getReturns,
  isMobile,
  trackMoengageEvent,
} from "../../../utils/commonMethods";
import FastImage from "../../../common/FastImage";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {convert} from "../../../locale/translateText";
import {INDIA} from "../../../utils/constants";
import {useNavigation} from "@react-navigation/native";
import {useSelector} from "react-redux";

const CancelOrder = ({eventDetails, orderStatus, closeSheet}) => {
  const {probe, call, isCancelAll} = eventDetails;
  const navigation = useNavigation();
  const {
    handleSubmit,
    formState: {errors, isSubmitting},
  } = useForm();

  let userInfo = useSelector(({profile}) => profile.profileData);
  let region = userInfo?.region_code ?? "INDIA";

  const onPlaceOrder = async () => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate("Profile");
      return;
    }

    if (isCancelAll) {
      const inputObj = {
        probe_id: probe?.id,
      };

      trackMoengageEvent("Clicked on Cancel All Orders", {
        ConfirmCancel: "Yes",
      });

      if (!isSubmitting) {
        let res = await Network.mmCancelAll(inputObj, true);
        if (res?.data?.success) {
          res.data = {
            ...res.data,
            respData: {
              title: "All Orders Cancelled Successfully",
              info: "Your orders have been cancelled. You can check your Portfolio for updates."
            }
          };
        } else {
          res.data = {
            ...res.data,
            message: res.data?.message || "Failed to cancel orders. Please try again.",
            error: "Order Not Executed"
          };
        }
        orderStatus(res?.data);
      }
    } else {
      const inputObj = {
        orderid: call?.orderid,
        probeid: probe?.id,
        callvalue: call?.callvalue,
        coins: call?.coins / ( 100 / defaultRange?.end ?? 100 ),
        appVersion: globalConst.appVersion,
        range: defaultRange.end,
      };

      trackMoengageEvent("Clicked on Cancel Order", {
        ConfirmCancel: "Yes",
        type: call?.status === "A" ? "Buy" : "Sell",
      });

      if (!isSubmitting) {
        let res =
          call?.status === "A"
            ? await Network.cancelBuyOrder(inputObj, true)
            : await Network.cancelSellOrder(inputObj, true);
        orderStatus(res?.data);
      }
    }
  };

  return (
    <>
      <View
        style={[
          {
            // width: Width.width,
            flex: 1,
            alignItems: "center",
            paddingHorizontal: 18,
            paddingTop: 15,
          },
          isMobile() ? {width: Width.width} : null,
        ]}>
        <FastImage
          style={styles.deleteBin}
          source={globalConfigurableData?.cancel_black()}
        />
        <FormTextLabel
          labelStyles={styles.cancelTitleText}
          label={isCancelAll ? "Do you want to cancel all pending orders?" : "Do you want to cancel your order?"}
        />
        {!isCancelAll && (
          <FormTextLabel
            labelStyles={styles.cancelText}
            label={"You are cancelling your order of x shares. "}
            rest={{
              callStatus: convert(call?.status === "H" ? "Sell" : "Buy"),
              callValue: convert(call?.callvalue === "Y" ? "Yes" : "No"),
              noofcontracts: getReturns(call?.noofcontracts),
            }}
          />
        )}
      </View>
      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15},
        ]}>
        <Button
          variant="primary"
          onPress={handleSubmit(onPlaceOrder)}
          translate={true}
        >
          Confirm
        </Button>
      </View>
    </>
  );
};

export default CancelOrder;

const styles = StyleSheet.create({
  deleteBin: {
    width: 42,
    height: 55,
  },
  cancelTitleText: {
    ...globalFontStyle.appFontHeading,
    color: globalConfigurableData.primaryTextColor1,
    textAlign: "center",
    marginTop: 20,
  },
  cancelText: {
    ...globalFontStyle.appFontHeadingRegular,
    color: globalConfigurableData.secondaryTextColor1,
    textAlign: "center",
    marginTop: 5,
  },
});
